import { render, staticRenderFns } from "./TicketsList.vue?vue&type=template&id=b2330ac8&scoped=true"
import script from "./TicketsList.vue?vue&type=script&lang=js"
export * from "./TicketsList.vue?vue&type=script&lang=js"
import style0 from "./TicketsList.vue?vue&type=style&index=0&id=b2330ac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2330ac8",
  null
  
)

export default component.exports